function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessBang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 8 15.5 C 5.996094 15.5 4.113281 14.71875 2.695312 13.304688 C 1.28125 11.886719 0.5 10.003906 0.5 8 C 0.5 5.996094 1.28125 4.113281 2.695312 2.695312 C 4.113281 1.28125 5.996094 0.5 8 0.5 C 10.003906 0.5 11.886719 1.28125 13.304688 2.695312 C 14.71875 4.113281 15.5 5.996094 15.5 8 C 15.5 10.003906 14.71875 11.886719 13.304688 13.304688 C 11.886719 14.71875 10.003906 15.5 8 15.5 Z M 8 15.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,69.803922%,34.901961%)",
      fillOpacity: 1
    },
    d: "M 8 1 C 6.128906 1 4.371094 1.726562 3.050781 3.050781 C 1.726562 4.371094 1 6.128906 1 8 C 1 9.871094 1.726562 11.628906 3.050781 12.949219 C 4.371094 14.273438 6.128906 15 8 15 C 9.871094 15 11.628906 14.273438 12.949219 12.949219 C 14.273438 11.628906 15 9.871094 15 8 C 15 6.128906 14.273438 4.371094 12.949219 3.050781 C 11.628906 1.726562 9.871094 1 8 1 M 8 0 C 12.417969 0 16 3.582031 16 8 C 16 12.417969 12.417969 16 8 16 C 3.582031 16 0 12.417969 0 8 C 0 3.582031 3.582031 0 8 0 Z M 8 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,69.803922%,34.901961%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 0 0 L 5 5 ",
    transform: "matrix(0.5,0,0,0.5,4.25,8.25)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,69.803922%,34.901961%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 12.187706 9.140293 L 0.000000000000003553 0 ",
    transform: "matrix(0.0435,-0.498,0.498,0.0435,6.75,10.75)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessBang);
export default __webpack_public_path__ + "static/media/success-bang.30b8a222f64c7f35928133e3cb6ebbc1.svg";
export { ForwardRef as ReactComponent };